/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-28 14:01:10
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-28 14:55:44
 * @FilePath: /wemeet-admin-new/src/hooks/usePagination.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import { ref, unref, watch } from 'vue'

export function useLocalPagination(list, opt = {}) {
  const currentPage = ref(opt.currentPage ?? 1)
  const pageSize = ref(opt.pageSize ?? 10)
  const total = ref(opt.total ?? 0)
  const data = ref([])

  function getData() {
    const size = unref(pageSize)
    const num = unref(currentPage)
    data.value = [...unref(list)].slice((num - 1) * size, size * num)
  }

  function onCurrentChange(num) {
    if (currentPage.value !== num) currentPage.value = num
    getData()
  }

  function onSizeChange(size) {
    if (pageSize.value !== size) pageSize.value = size
    currentPage.value = 1
  }

  watch(
    list,
    (arr) => {
      total.value = arr.length
      if (currentPage.value !== 1) {
        currentPage.value = 1
      } else {
        getData()
      }
    },
    { immediate: true }
  )

  return {
    data,
    currentPage,
    pageSize,
    total,
    onSizeChange,
    onCurrentChange,
  }
}
